/*
 * Ventana «Personalizar producto» de Markegifts: ver en grande la foto de cada zona de marcaje.
 * Al pasar el ratón por la miniatura sale al lado; al pulsarla (o tocarla en el móvil) se abre encima.
 * Solo aspecto: pulsar la miniatura no abre ni marca la zona.
 */
(() => {
  const modal = document.getElementById('personalizeModal');
  if (!modal || modal.dataset.zoom) return;
  modal.dataset.zoom = '1';

  const conRaton = window.matchMedia('(hover: hover) and (pointer: fine)');
  const nombreDe = (img) => img.closest('.accordion-button')?.querySelector('.mk-area__nombre')?.textContent.trim() || '';

  // Vista al pasar el ratón
  const vista = document.createElement('div');
  vista.className = 'mk-zoom';
  vista.setAttribute('aria-hidden', 'true');
  vista.innerHTML = '<img alt=""><span></span>';
  modal.appendChild(vista);

  const mostrar = (img) => {
    if (!conRaton.matches) return;
    vista.querySelector('img').src = img.currentSrc || img.src;
    vista.querySelector('span').textContent = nombreDe(img);
    const r = img.getBoundingClientRect();
    const ancho = 300;
    const alto = 340;
    const izquierda = r.right + 14 + ancho < window.innerWidth ? r.right + 14 : Math.max(8, r.left - 14 - ancho);
    const arriba = Math.min(Math.max(8, r.top + r.height / 2 - alto / 2), window.innerHeight - alto - 8);
    vista.style.left = `${izquierda}px`;
    vista.style.top = `${arriba}px`;
    vista.classList.add('is-visible');
  };
  const ocultar = () => vista.classList.remove('is-visible');

  modal.addEventListener('mouseover', (e) => {
    if (e.target.matches('.mk-area__img')) mostrar(e.target);
  });
  modal.addEventListener('mouseout', (e) => {
    if (e.target.matches('.mk-area__img')) ocultar();
  });
  modal.addEventListener('scroll', ocultar, true);

  // Vista grande al pulsar
  const caja = document.createElement('div');
  caja.className = 'mk-lupa';
  caja.setAttribute('role', 'dialog');
  caja.setAttribute('aria-modal', 'true');
  caja.setAttribute('aria-label', 'Zona de marcaje en grande');
  caja.hidden = true;
  caja.innerHTML = '<figure class="mk-lupa__caja"><button type="button" class="mk-lupa__cerrar" aria-label="Cerrar"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button><img alt=""><figcaption></figcaption></figure>';
  modal.appendChild(caja);

  const cerrar = () => {
    caja.hidden = true;
  };
  const abrir = (img) => {
    ocultar();
    const foto = caja.querySelector('img');
    foto.src = img.currentSrc || img.src;
    const nombre = nombreDe(img);
    foto.alt = nombre ? `Zona de marcaje: ${nombre}` : 'Zona de marcaje';
    caja.querySelector('figcaption').textContent = nombre;
    caja.hidden = false;
    caja.querySelector('.mk-lupa__cerrar').focus();
  };

  // En window y en captura: Bootstrap escucha el acordeón en document, también en captura, y tiene que llegar antes
  // para que pulsar la miniatura no abra ni cierre la zona
  window.addEventListener(
    'click',
    (e) => {
      if (!(e.target instanceof Element) || !e.target.matches('#personalizeModal .mk-area__img')) return;
      e.preventDefault();
      e.stopPropagation();
      abrir(e.target);
    },
    true
  );
  caja.addEventListener('click', (e) => {
    if (e.target === caja || e.target.closest('.mk-lupa__cerrar')) cerrar();
  });
  // Esc cierra la foto, no la ventana de personalizar
  modal.addEventListener(
    'keydown',
    (e) => {
      if (e.key === 'Escape' && !caja.hidden) {
        e.stopPropagation();
        cerrar();
      }
    },
    true
  );
  modal.addEventListener('hidden.bs.modal', () => {
    cerrar();
    ocultar();
  });
})();
